import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/upload.svg'
import _imports_1 from '../../assets/illus-home.png'
import _imports_2 from '../../assets/svgs/upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-314c2e1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate__animated animate__fadeIn"
}
const _hoisted_2 = { class: "flex justify-end space-x-4" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1" }, "Download", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-b-2 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-medium text-primary" }, "Other documents")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "flex flex-row justify-end items-end" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "lg:h-6 lg:w-6 md:h-6 md:w-6 w-4 h-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1" }, "Download", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "space-y-2 pt-8 w-auto rounded h-full flex items-center bg-gray-100 animate__animated animate__fadeIn"
}
const _hoisted_19 = { class: "container grid justify-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-10 w-18"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base pt-5 text-black" }, "You have not uploaded any file yet.", -1))
const _hoisted_22 = { class: "pt-10 pb-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Upload a file")
], -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PdfView = _resolveComponent("PdfView")!
  const _component_ResourceViewer = _resolveComponent("ResourceViewer")!
  const _component_FilesForm = _resolveComponent("FilesForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.file !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              href: _ctx.file,
              target: "_blank",
              download: "",
              class: "px-4 py-2 text-primary hover:bg-gray-100 text-lg rounded-full border-2 border-primary flex items-center flex-row"
            }, _hoisted_6, 8, _hoisted_3),
            _createVNode(_component_Button, {
              variant: "contained",
              label: "Upload a file",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = !_ctx.showModal))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_PdfView, {
            key: undefined,
            file: _ctx.file
          }, null, 8, ["file"]),
          (_ctx.documents.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (_ctx.getFileExtension(document.document.url) === 'pdf')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("a", {
                                href: document.document.url,
                                target: "_blank",
                                download: "",
                                class: "lg:px-4 lg:py-2 md:px-4 md:py-2 px-2 py-1 text-primary hover:bg-gray-100 lg:text-lg mg:text-lg text-sm rounded-full border-2 border-primary flex items-center flex-row"
                              }, _hoisted_16, 8, _hoisted_13)
                            ]),
                            _createVNode(_component_PdfView, {
                              key: undefined,
                              file: document?.document?.url
                            }, null, 8, ["file"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_ResourceViewer, {
                            url: document.document.url
                          }, null, 8, ["url"])
                        ]))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = !_ctx.showModal)),
                class: "text-white px-3 py-3 rounded-full border-2 bg-primary text-sm"
              }, _hoisted_24)
            ])
          ])
        ])),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false)),
      size: "w-1/2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FilesForm, {
          onCloseInForm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false)),
          candidateId: _ctx.candidateId
        }, null, 8, ["candidateId"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}